// src/components/ProductCard.js
import React from 'react';
import { useStore } from '../context/StoreContext';

function ProductCard({ product }) {
    const {openProductModal} = useStore();

    return (
        <div 
            className="bg-[#292929] rounded-2xl shadow-lg overflow-hidden flex flex-col transition-transform duration-300 ease-in-out hover:scale-105 cursor-pointer"
            onClick={() => openProductModal(product)}
        >
            <div className="aspect-square bg-[#222222] overflow-hidden">
                <img 
                    src={product.imageUrl} 
                    alt={product.title} 
                    className="w-full h-full object-cover" 
                />
            </div>
            
            <div className="p-4 flex flex-col flex-grow">
                <h3 className="text-lg font-semibold text-white h-[84px] line-clamp-3">
                    {product.title}
                </h3>
                
                <div className="mt-auto pt-4">
                    <span className="text-xl font-bold text-lime-400">
                        ${product.price.toFixed(2)}
                    </span>
                </div>
            </div>
        </div>
    );
}

export default ProductCard;